interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "max-w-2xl mx-auto text-center" : "max-w-2xl"}>
      <div
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium mb-4"
      >
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          <i className="ri-price-tag-3-line"></i>
        </span>
        {eyebrow}
      </div>
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
}